import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";

/* Logos */
import LogoAssobenefit from "../../../assets/images/loghi 2x/Assobenefit.png";
import LogoUNHCR from "../../../assets/images/loghi 2x/Unhcr.png";
import LogoSustainabilityMakers from "../../../assets/images/loghi 2x/SustainabilyMakers.png";
import LogoMaCa from "../../../assets/images/loghi 2x/Maca.png";
import LogoMuseimpresa from "../../../assets/images/loghi 2x/MuseImpresa.png";
import LogoASVIS from "../../../assets/images/loghi 2x/Asvis.png";

import LogoAssonime from "../../../assets/images/loghi 2x/Assonime.png";
import LogoSodalitas from "../../../assets/images/loghi 2x/Sodalitas.png";
import LogoUNGlobalCompact from "../../../assets/images/loghi 2x/UnGlobalCompact.png";
import LogoAseguradoresChile from "../../../assets/images/loghi 2x/AsociacionDeAsiguradores.png";
import LogoCETIF from "../../../assets/images/loghi 2x/Cetif.png";
import LogoConsultaTorino from "../../../assets/images/loghi 2x/Consulta.png";

import LogoANIA from "../../../assets/images/loghi 2x/Ania.png";
import LogoValoreD from "../../../assets/images/loghi 2x/ValoreD.png";
import LogoItalianTechAlliance from "../../../assets/images/loghi 2x/ItalianTechAlliance.png";
import LogoEurapco from "../../../assets/images/loghi 2x/Eurapco.png";
import LogoAMICE from "../../../assets/images/loghi 2x/Amice.png";
import LogoTorinoSocialImpact from "../../../assets/images/loghi 2x/TorinoSocialImpact.png";

import LogoHellenicStatAuth from "../../../assets/images/loghi 2x/HellenicStatisticalAuthority.png";
import LogoHellenicAssocInsurance from "../../../assets/images/loghi 2x/HellenicAssociationInsuranceCompanies.png";
import LogoAthensChamber from "../../../assets/images/loghi 2x/AthensChamberCommerceIndustry.png";
import LogoMotorInsurersGreece from "../../../assets/images/loghi 2x/MotorInsurersBureau-Greece.png";

import LogoPSI from "../../../assets/images/loghi 2x/PSI.png";
import LogoSocialImpactAgenda from "../../../assets/images/loghi 2x/SocialImpactAgenda.png";
import LogoAEF from "../../../assets/images/loghi 2x/Aef.png";
import LogoCodespa from "../../../assets/images/loghi 2x/codespa.png";
import LogoUNESPA from "../../../assets/images/loghi 2x/Unespa.png";
import LogoForetica from "../../../assets/images/loghi 2x/Foretica.png";

import LogoCCICile from "../../../assets/images/loghi 2x/CameraCommercioItalianaCile.png";
import LogoEWI from "../../../assets/images/loghi 2x/Ewi.png";
import LogoForumFinanzaSostenibile from "../../../assets/images/loghi 2x/ForumFinanzaSostenibile.png";

/* ---- Righe con colonne specifiche ---- */
const ROWS = [
  {
    cols: 6,
    items: [
      { alt: "Assobenefit", src: LogoAssobenefit },
      { alt: "UNHCR", src: LogoUNHCR },
      { alt: "Sustainability Makers", src: LogoSustainabilityMakers },
      { alt: "MaCa", src: LogoMaCa },
      { alt: "Museimpresa", src: LogoMuseimpresa },
      { alt: "ASviS", src: LogoASVIS },
    ],
  },
  {
    cols: 6,
    items: [
      { alt: "Assonime", src: LogoAssonime },
      { alt: "Sodalitas", src: LogoSodalitas },
      { alt: "UN Global Compact", src: LogoUNGlobalCompact },
      { alt: "Asociación de Aseguradores de Chile", src: LogoAseguradoresChile },
      { alt: "CETIF", src: LogoCETIF },
      { alt: "Consulta Torino", src: LogoConsultaTorino },
    ],
  },
  {
    cols: 6,
    items: [
      { alt: "ANIA", src: LogoANIA },
      { alt: "Valore D", src: LogoValoreD },
      { alt: "Italian Tech Alliance", src: LogoItalianTechAlliance },
      { alt: "Eurapco", src: LogoEurapco },
      { alt: "AMICE", src: LogoAMICE },
      { alt: "Torino Social Impact", src: LogoTorinoSocialImpact },
    ],
  },
  {
    cols: 4,
    items: [
      { alt: "Hellenic Statistical Authority", src: LogoHellenicStatAuth },
      { alt: "Hellenic Association of Insurance Companies", src: LogoHellenicAssocInsurance },
      { alt: "Athens Chamber of Commerce & Industry", src: LogoAthensChamber },
      { alt: "Motor Insurers’ Bureau Greece", src: LogoMotorInsurersGreece },
    ],
  },
  {
    cols: 6,
    items: [
      { alt: "PSI – Principles for Sustainable Insurance", src: LogoPSI },
      { alt: "Social Impact Agenda", src: LogoSocialImpactAgenda },
      { alt: "AEF Fundaciones", src: LogoAEF },
      { alt: "Codespa", src: LogoCodespa },
      { alt: "UNESPA", src: LogoUNESPA },
      { alt: "Forética", src: LogoForetica },
    ],
  },
  {
    cols: 3,
    items: [
      { alt: "Camera di Commercio Italiana in Cile", src: LogoCCICile },
      { alt: "EWI – Empower Women in Insurance", src: LogoEWI },
      { alt: "Forum per la Finanza Sostenibile", src: LogoForumFinanzaSostenibile },
    ],
  },
];

/* mapping cols->classe tailwind (classi esplicite per JIT) */
const COLS_CLASS = {
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  6: "md:grid-cols-6",
};

export default function Network({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Participation in associations and membership in international networks", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[2000] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Participation in associations and membership in international networks"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Network")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          <h2 className="text-[#5B6A25] text-[30px] md:text-[40px] font-bold leading-[1.1em]">
            Participation in associations <br />
            and adherence to international networks
          </h2>

          <p className="text-[#0E3761] text-[16px] md:text-[24px] mt-2 leading-[1.1em] mb-6">
            Reale Group deeply believes in active participation in national and international alliances and associations, 
            which it interprets as accelerators of development and innovation and as a way to encourage mutual responsibility.
          </p>

          {/* Righe con colonne diverse (mobile 2 col fisse) */}
          <div className="mt-12 flex flex-col gap-10 md:gap-14">
            {ROWS.map((row, rIdx) => (
              <div
                key={rIdx}
                className={`grid grid-cols-2 ${COLS_CLASS[row.cols]} gap-x-8 gap-y-10 md:gap-y-14 place-items-center`}
              >
                {row.items.map((l, i) => (
                  <div key={i} className="w-full flex items-center justify-center px-[20px]">
                    <img
                      src={l.src}
                      alt={l.alt || "logo"}
                      className="w-auto select-none"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
